import { useCallback } from 'react';

import { useServiceFeatures } from 'hooks/useServiceContext';
import { updateUserDefaultPriceMargin } from 'lib/api/updateUserDefaultPriceMargin';
import { ProfitType } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';

export function useUpdateUserDefaultPriceMargin() {
  const { updateConfigurations } = useServiceFeatures();

  return useCallback(
    async (defaultPriceMargin: number, defaultPriceMarginType: ProfitType) => {
      const res = await updateUserDefaultPriceMargin(
        defaultPriceMargin,
        defaultPriceMarginType
      );

      if (res.isOk()) {
        updateConfigurations({ defaultPriceMargin, defaultPriceMarginType });
      }

      return res;
    },
    [updateConfigurations]
  );
}
